import React ,{useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, Divider, makeStyles, Snackbar, Typography } from '@material-ui/core'
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { deleteStokGudang, emptyGudangMessage } from '../../../config/redux/action';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const DeleteStokGudang = ({HandleClickCloseDeleteDialog,idstokgudang,namabarang,varian,...rest}) => {
    const {data} = useSelector(state=>state.loginReducers);
    const {isLoadingStokGudang,editStokMessage} = useSelector(state=>state.stokGudangReducers);
    const dispatch = useDispatch();
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const useStyle = makeStyles((theme)=>({
        titleDialog:{
            width:'400px',
            [theme.breakpoints.down('sm')]:{
                width:'250px',
            },
            textAlign:'center',
        },
        contentDelete:{
            padding:'10px'
        },
        button:{
            display:'flex',
            justifyContent:'space-between',
            paddingBottom:"5px",
        },
        textFiled:{
            width:'100%',
            paddingBottom:"7px",
        },
    }));
    const classes=useStyle();
    const [openSnackbar,setOpenSnackbar] = useState(false);
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenSnackbar(false);
        setTimeout(() => {
            dispatch(emptyGudangMessage(""));
        }, 200);
      };
    const onSubmit=()=>{
        dispatch(deleteStokGudang(idstokgudang,token,setOpenSnackbar,HandleClickCloseDeleteDialog));
    }
    return (
        <div>
            <Dialog open={false} {...rest}>
            <DialogTitle className={classes.titleDialog} id="delete-stokgudang-dialog">Hapus Data Stok Gudang</DialogTitle>
                <Divider/>
                <DialogContent>
                    <div className={classes.contentDelete}>
                    <Typography align='center'>Apakah anda yakin akan menghapus data ini</Typography>
                    <Typography align='center'>{namabarang} {varian !== '' ? (varian) : ""}?</Typography>
                    </div>
                <div className={classes.button}>
                <Button variant="contained" color="primary" onClick={onSubmit} disabled={isLoadingStokGudang}>Hapus</Button>
                <Button variant="contained" color="secondary" onClick={HandleClickCloseDeleteDialog}  disabled={isLoadingStokGudang}>Keluar</Button>
                </div>
                </DialogContent>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={editStokMessage === "Data stok gudang berhasil dihapus" ? "success" : "error"} 
                onClick={HandleClickCloseDeleteDialog}>
                    {editStokMessage}</Alert>
            </Snackbar>
        </div>
    )
}

export default DeleteStokGudang
